import "./styles.css";
import { SuntraceRuntime } from "./runtime/SuntraceRuntime";

const root = document.querySelector<HTMLElement>("#app");

if (!root) {
  throw new Error("SUNTRACE requires an app root");
}

const runtime = new SuntraceRuntime(root);

void runtime.initialize().catch((error: unknown) => {
  if (error instanceof DOMException && error.name === "AbortError") {
    return;
  }
  const message = error instanceof Error ? error.message : "Renderer initialization failed";
  const errorView = document.createElement("main");
  const heading = document.createElement("h1");
  const detail = document.createElement("p");
  errorView.className = "fatal-error";
  heading.textContent = "Unable to start SUNTRACE";
  detail.textContent = message;
  errorView.append(heading, detail);
  root.replaceChildren(errorView);
});
